import { Cart, useResendCartReceipt } from '@givebacks/api/store';
import {
  ButtonMantine,
  DonorInfoCard,
  Group,
  Modal,
  ModalProps,
  Stack,
  Title,
  notifications,
} from 'ui';

type ResendReceiptModalProps = {
  cart: Cart;
};

type ResendReceiptModalContentProps = {
  onClose: () => void;
  cart: Cart;
  causeId: string;
};
const ResendReceiptModalContent = ({ onClose, cart, causeId }: ResendReceiptModalContentProps) => {
  const { mutate: sendCartReceipt } = useResendCartReceipt();

  const handleResendReceipt = () => {
    sendCartReceipt(
      { cartId: cart.uuid, causeId },
      {
        onSuccess() {
          notifications.show({
            message: `Receipt has been sent to ${cart.email}`,
            variant: 'success',
          });
          onClose();
        },
        onError() {
          notifications.show({ message: 'Error sending receipt', variant: 'error' });
        },
      }
    );
  };

  return (
    <Stack gap="lg">
      <Title order={4}>Would you like to resend the receipt to the donor's email?</Title>
      <DonorInfoCard
        donorName={`${cart.first_name} ${cart.last_name}`}
        email={cart.email}
        donationType={cart.status == 'pledged' ? 'pledge' : 'flat'}
        donationAmount={cart.total}
      />
      <Group justify="flex-end">
        <ButtonMantine size="md" variant="subtle" onClick={onClose}>
          Cancel
        </ButtonMantine>
        <ButtonMantine size="md" color="cerise" onClick={handleResendReceipt}>
          Resend Receipt
        </ButtonMantine>
      </Group>
    </Stack>
  );
};
const ResendReceiptModal = ({ onClose, cart, ...rest }: ResendReceiptModalProps & ModalProps) => {
  return (
    <Modal title="Resend Receipt" size="lg" onClose={onClose} {...rest}>
      <ResendReceiptModalContent onClose={onClose} cart={cart} causeId={cart.cause_id} />
    </Modal>
  );
};

export { ResendReceiptModal };
